import React, { Component, useState, useEffect, useRef } from 'react';
import { Button, Table, Input, Form, FormFeedback, FormGroup, FormText } from 'reactstrap';
import moment from "moment";

const AthKeycardGA = (props) => {
    const [selectList, setSelectList] = useState([]);
    const [selectOn, setSelectOn] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableReady, setTableReady] = useState(false);
    const [searchboxValue, setSearchboxValue] = useState("");
    const [studentSelect, setStudentSelect] = useState();
    const [sportSelect, setSportSelect] = useState();
    const [sortBy, setSortBy] = useState(true);

    useEffect(() => {
        getTable();
        //console.log("default select list: " + JSON.stringify(selectList));
    }, [])

    function getTable() {
        //console.log("props: " + props.userData)
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: props.userData.level
        }
        fetch('GetGATable', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { handleTableResponse(responseJSON); })
        localStorage.setItem("lastFetch", moment());
    }

    function handleTableResponse(input) {
        setTableData(input);
        setTableReady(true);
    }

    function searchStudent() {
        //console.log("searching for : " + searchboxValue)
        //if (searchboxValue == "") {
        //    return;
        //}
        if (searchboxValue != "") {
            let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let toSend = {
                userLevel: props.userData.level,
                searchstring: searchboxValue
            }
            fetch('GetGASearchData', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                .then((response) => response.json())
                .then((responseJSON) => { setSelectList(responseJSON) })
                .then((responseSet) => { setSelectOn(true) })
                .then((responseStu) => { setStudentSelect("BLANK") })
            localStorage.setItem("lastFetch", moment());
        }
        //console.log("after fetch: " + JSON.stringify(selectList))
    }

    function deleteGA(pk) {
        //console.log("deleting: " + pk);
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: props.userData.level,
            targetpk: pk
        }
        fetch('RemoveGA', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTableData(responseJSON) })
        localStorage.setItem("lastFetch", moment());
    }

    function submitNewGA(e) {
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        if (studentSelect == undefined || sportSelect == undefined || studentSelect == "BLANK") {
            return;
        }
        //console.log("adding: " + studentSelect + ", " + sportSelect);
        let toSend = {
            userLevel: props.userData.level,
            student: studentSelect,
            sport: sportSelect
        }
        fetch('AddGA', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTableData(responseJSON) })
        localStorage.setItem("lastFetch", moment());
    }

    return (
        <div>
            <h2>GAs</h2><br />
                <div className="inlineCustom">
                <Input type="text" name="search" id="search" value={searchboxValue} onChange={e => setSearchboxValue(e.target.value)} onBlur={() => searchStudent()} /><p />
            </div>
            &emsp;&emsp;
            <div className="inlineCustom">
                    <Input type="select" name="student" id="student" value={studentSelect} onChange={e => setStudentSelect(e.target.value)}>
                        {selectList.length == 0 && <option value="BLANK" selected disabled>Search for a student</option>}
                    {selectList.length > 0 && <option value="BLANK" selected disabled>Select Student...</option> }
                        {selectList.map(item => (
                            <option value={item.pcid}>{item.studentname}</option>
                            )) }
                </Input>
            </div>
                &emsp;&emsp;
            <div className="inlineCustom">
                    <Input type="select" name="sport" id="sport" value={sportSelect} onChange={e => setSportSelect(e.target.value)}>
                        <option disabled selected value="BLANK">Select Sport...</option>
                        {props.sportsList.map(item => (
                            <option value={item.sportcode}>{item.sportname}</option>
                            )) }
                </Input>
            </div>
                &emsp;&emsp;
                <Button onClick={e => submitNewGA(e)} outline color="success">Add</Button>
            <p />
            {tableReady && <Table>
                <thead>
                    <tr>
                        <th>Student &emsp;<Input type="checkbox" name="namesort" id="namesort" checked={sortBy} onClick={(e) => setSortBy(e.target.checked) } /></th>
                        <th>Sport&emsp;<Input type="checkbox" name="sportsort" id="sportsort" checked={!sortBy} onClick={(e) => setSortBy(!e.target.checked) } /></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {sortBy && tableData
                        .sort(function (x, y) {
                        return x.student.toUpperCase() == y.student.toUpperCase() ? 0 : x.student.toUpperCase() > y.student.toUpperCase() ? 1 : -1;
                        }
                    )
                        .map(item => (
                        <tr>
                            <td>{item.student}</td>
                            <td>{item.sport}</td>
                            <td><Button outline color="danger" onClick={() => deleteGA(item.pk) }>Delete</Button></td>
                        </tr>
                        ))}
                    {!sortBy && tableData
                        .sort(function (x, y) {
                            let a = x.sport.substring(3).toUpperCase()
                            let b = y.sport.substring(3).toUpperCase()
                            return a == b ? 0 : a > b ? 1 : -1;
                        })
                        .map(item => (
                            <tr>
                                <td>{item.student}</td>
                                <td>{item.sport}</td>
                                <td><Button outline color="danger" onClick={() => deleteGA(item.pk)}>Delete</Button></td>
                            </tr>
                        ))}
                </tbody>
            </Table>}
        </div>
        );
}

export default AthKeycardGA;